import defaults from 'lodash/defaults';
import get from 'lodash/get';
import Breadcrumb from '@Services/Breadcrumb';
import * as ResultsDataManage from '@Services/ResultsDataManage';
import * as qbHelpersService from '@Services/QBHelpers';
import * as Results from '@Services/Results';

/**
 * @ngdoc method
 * @methodOf app.results:ReactTargetHelper
 * @name getProteinName
 * @param {Object} protein
 * @description combine protein name
 */
function getProteinName(protein) {
  let name = protein.protein || '';

  if (protein.species || protein.targetType) {
    name += ' (';
    if (protein.species) {
      name += protein.species;
    }
    if (protein.targetType) {
      if (protein.species) {
        name += ', ';
      }
      name += protein.targetType;
    }
    name += ')';
  }

  return name;
}

/**
 * @ngdoc method
 * @methodOf app.results:ReactTargetHelper
 * @name isTestedSample
 * @param {Object} target
 * @description check if TESTED_SAMPLE
 */
function isTestedSample(target) {
  return get(target, 'mostActiveSubstanceDetails.type', '') === 'TESTED_SAMPLE';
}

/**
 * @ngdoc method
 * @methodOf app.results:ReactTargetHelper
 * @name openElementLink
 * @param {String} type
 * @param {Object} target
 * @param {Object} requestParams
 * @description opens right-hand link
 */
function openElementLink(type, target, requestParams) {
  const searchParams = {
    ...requestParams,
    databaseId: target.databaseId,
    index: target.index,
    id: qbHelpersService.getElementId('tgitems', target),
  };

  return Results.getRelatedResults(type, searchParams, 'tgitems')
    .then((data) => {
      const { searchId } = searchParams;
      defaults(data, { searchId });

      Breadcrumb.createBreadcrumb(data, data.resultSize)
        .then(() => {
          const { resultName, context, databaseId, hitSetKey } = data;
          ResultsDataManage.redirectToResults({
            resultName,
            context,
            databaseId,
            hitSetKey,
            searchId,
            resetBreadcrumbs: false, // don't reset the breadcrumbs
          });
        })
        .catch(Logger.error);
    })
    .catch(Logger.error);
}

const ReactTargetHelper = {
  getProteinName,
  isTestedSample,
  openElementLink,
};

export default ReactTargetHelper;
